module.exports = __webpack_public_path__ + "img/card03.0e97a05e.png";